import { MatSelect } from '@angular/material/select';

export const ROUTING_MAT_SELECT_BODY_CLASS = 'routing-mat-select-open';
export const ROUTING_MAT_SELECT_PANEL_CLASS = 'routing-mat-select-panel';

/**
 * Non-blocking mat-select overlay: transparent backdrop passes clicks through;
 * outside click closes the active panel (Rule Config / Routing pattern).
 */
export class RoutingMatSelectOverlayHelper {
  private activeSelect: MatSelect | null = null;
  private outsideClickListener: ((event: Event) => void) | null = null;

  onOpenedChange(opened: boolean, select: MatSelect): void {
    if (opened) {
      this.activeSelect = select;
      document.body.classList.add(ROUTING_MAT_SELECT_BODY_CLASS);
      this.attachOutsideClickListener();
      return;
    }
    if (this.activeSelect === select) {
      this.cleanup();
    }
  }

  destroy(): void {
    this.cleanup();
  }

  private attachOutsideClickListener(): void {
    this.detachOutsideClickListener();
    this.outsideClickListener = (event: Event) => {
      const target = event.target as Node | null;
      const select = this.activeSelect;
      if (!target || !select) {
        return;
      }
      const triggerEl = select._elementRef?.nativeElement as HTMLElement | undefined;
      if (triggerEl?.contains(target)) {
        return;
      }
      const panels = document.querySelectorAll(`.${ROUTING_MAT_SELECT_PANEL_CLASS}`);
      for (let i = 0; i < panels.length; i++) {
        if (panels[i].contains(target)) {
          return;
        }
      }
      if (select.panelOpen) {
        select.close();
      }
    };
    setTimeout(() => {
      if (this.outsideClickListener) {
        document.addEventListener('click', this.outsideClickListener, true);
        document.addEventListener('touchend', this.outsideClickListener, true);
      }
    }, 0);
  }

  private detachOutsideClickListener(): void {
    if (this.outsideClickListener) {
      document.removeEventListener('click', this.outsideClickListener, true);
      document.removeEventListener('touchend', this.outsideClickListener, true);
      this.outsideClickListener = null;
    }
  }

  private cleanup(): void {
    document.body.classList.remove(ROUTING_MAT_SELECT_BODY_CLASS);
    this.activeSelect = null;
    this.detachOutsideClickListener();
  }
}
